module.exports = __webpack_public_path__ + "img/myPublishCenter.0c52666.png";